import { render, staticRenderFns } from "./GoodsEmpty.vue?vue&type=template&id=2128816c&scoped=true&"
var script = {}
import style0 from "./GoodsEmpty.vue?vue&type=style&index=0&id=2128816c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128816c",
  null
  
)

export default component.exports